import axios from 'axios';
// import { window.API_BASE_URL } from '../config.js';
import Cookies from 'universal-cookie'

const initialState = [];

// Action Types
const GET_BUSINESS = 'GET_BUSINESS';
const UPDATE_BUSINESS = 'UPDATE_BUSINESS';
const POST_BUSINESS = 'POST_BUSINESS';
const DELETE_BUSINESS = 'DELETE_BUSINESS';

// Reducer
export default function businessReducer(state = initialState, action) {
    switch (action.type) {
        case GET_BUSINESS:
            return action.payload; // Reemplaza el estado actual con nuevos datos de negocio
        case UPDATE_BUSINESS:
            const { id, data } = action.payload;

            // Actualizar el negocio según el id o añadir uno nuevo si no existe
            const updatedBusinesses = state.some(business => business.id === id)
                ? state.map(business =>
                    business.id === id ? { ...business, ...data } : business
                  )
                : [...state, { id, ...data }];

            return updatedBusinesses;
        case POST_BUSINESS:
            return [...state, action.payload]; // Añade un nuevo negocio al estado
        case DELETE_BUSINESS:
            return state.filter(business => business.id !== action.payload.id); // Elimina el negocio por id
        default:
            return state;
    }
}

// Action Creators
export const UpdateBusiness = (id, data) => ({
    type: UPDATE_BUSINESS,
    payload: { id, data },
});

export const GetBusinesses = (businesses) => ({
    type: GET_BUSINESS,
    payload: businesses,
});

export const PostBusiness = (business) => ({
    type: POST_BUSINESS,
    payload: business,
});

export const DeleteBusiness = (id) => ({
    type: DELETE_BUSINESS,
    payload: { id },
});

// API Integration Functions
export const fetchBusinessesFromAPI = () => async (dispatch) => {
    try {
        const cookies = new Cookies()

        const response = await axios.get(window.API_BASE_URL+'/BusinessLine',{headers: {'Authorization': `Bearer ${cookies.get('token')}`}}); // GET request
        const data = await response.data;
        dispatch(GetBusinesses(data));
    } catch (error) {
        console.error('Error fetching businesses:', error);
    }
};

export const createBusinessInAPI = (business) => async (dispatch) => {
    try {
        const cookies = new Cookies()

        const response = await axios.post(window.API_BASE_URL+'/BusinessLine',
           business,
           {headers: {'Authorization': `Bearer ${cookies.get('token')}`}}
        );
        const data = await response.data;
        dispatch(PostBusiness(data));
    } catch (error) {
        console.error('Error creating business:', error);
    }
};

export const updateBusinessInAPI = (business) => async (dispatch) => {
    try {
        const cookies = new Cookies()

        const response = await axios.put(window.API_BASE_URL+'/BusinessLine',
           business,
           {headers: {'Authorization': `Bearer ${cookies.get('token')}`}}
        );
        const data = await response.data;
        dispatch(UpdateBusiness(business.id, data));
    } catch (error) {
        console.error('Error updating business:', error);
    }
};

export const deleteBusinessFromAPI = (id) => async (dispatch) => {
    try {
        const cookies = new Cookies()

        await axios.delete(`${window.API_BASE_URL}/BusinessLine/${id}`,{headers: {'Authorization': `Bearer ${cookies.get('token')}`}});
        dispatch(DeleteBusiness(id));
    } catch (error) {
        console.error('Error deleting business:', error);
    }
};